import styled from 'theme';

export const LocaleContainer = styled.div`
  margin-left: 0.8125rem;
  margin-right: 0.3125rem;
`;
